module.exports = __webpack_public_path__ + "img/newsbanner.bf1f75f9.jpg";